/* eslint-disable no-unused-vars */
import React from "react";
import { Button, FormTextInput } from "../../../components";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const StageForm = (props) => {
  const {
    errorMessage,
    setMessage,
    handleChangeFormData = () => {},
    initialValue = {},
    actionType,
    handleModalClose,
  } = props;

  const [name, setName] = React.useState({
    value: initialValue.name ? initialValue.name : "",
    error: false,
    success: false,
  });

  const [description, setDescription] = React.useState({
    value: initialValue.description ? initialValue.description : "",
    error: false,
    success: false,
  });

  const handleChangeName = (value) => {
    setMessage(null);
    setName(value);
  };

  const handleChangeDescription = (value) => {
    setDescription(value);
  };

  const handleSaveData = () => {
    const formData = {
      name: name.value,
      description: description.value,
    };
    handleChangeFormData(formData);
  };

  const CreateTitle = Strings["Stage.CreateTitle"],
    EditTitle = Strings["Stage.EditTitle"],
    NameLabel = Strings["Stage.NameLabel"],
    NamePlaceholder = Strings["Stage.NamePlaceholder"],
    NameCustomError = Strings["Stage.NameCustomError"],
    DescriptionLabel = Strings["Stage.DescriptionLabel"],
    DescriptionPlaceholder = Strings["Stage.DescriptionPlaceholder"],
    DescriptionCustomError = Strings["Stage.DescriptionCustomError"],
    SaveBtn = Strings["Stage.SaveBtn"],
    UpdateBtn = Strings["Stage.UpdateBtn"],
    CancelBtn = Strings["Stage.CancelBtn"];

  let isValueChanged = name.value === initialValue.name;
  // description.value === initialValue.description

  let disable =
    name.error ||
    // description.error ||
    name.value === "" ||
    // description.value === '' ||
    name.success === false ||
    isValueChanged;

  //edit
  let isValueChangededit =
    name.value === initialValue.name &&
    description.value === initialValue.description;

  let Editdisable =
    name.error ||
    description.error ||
    name.value === "" ||
    description.value === "" ||
    (name.success === false && description.success === false) ||
    isValueChangededit;

  return (
    <div className="modalFormContainer">
      <h2>{actionType === "add" ? CreateTitle : EditTitle}</h2>
      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}
      <FormTextInput
        type="alpha"
        starProps={true}
        label={NameLabel}
        placeholder={NamePlaceholder}
        Value={name.value}
        onChangeText={handleChangeName}
        Validate={true}
        CustomErrorLine={NameCustomError}
        editable
        maxLength={30}
      />
      <FormTextInput
        type="text"
        label={DescriptionLabel}
        placeholder={DescriptionPlaceholder}
        Value={description.value}
        onChangeText={handleChangeDescription}
        // Validate={actionType === "add" ? false : true}
        Validate={false}
        CustomErrorLine={DescriptionCustomError}
        multiline={true}
        editable
      />

      <div style={{ display: "flex", marginTop: "1.5rem" }}>
        <Button
          buttonName={actionType === "add" ? SaveBtn : UpdateBtn}
          buttonStyle={{ backgroundColor: colors.primary }}
          disable={actionType === "add" ? disable : false}
          onClick={handleSaveData}
        />
        <Button
          buttonName={CancelBtn}
          buttonStyle={{ backgroundColor: colors.darkgrey, marginLeft: "10px" }}
          onClick={() => {
            handleModalClose();
            setMessage(null);
          }}
        />
      </div>
    </div>
  );
};

export default StageForm;
